import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import { Icon } from '../../../common/html/icon'
import { valToPercent } from '../../../helpers/value'
import { HandleDetail } from '../../common/handleDetail'
import { selectPeriod } from '../../common/period/slice'
import classes from './index.module.scss'
import { changeIsHighlight, selectData } from './store/slice'

export const HighRiskCompanies = ({ isDynamicReport }) => {
  const dispatch = useDispatch()

  const locale = useSelector((state) => state.i18n.locale)
  const period = useSelector(selectPeriod)
  const data = useSelector(selectData)

  const onMouseOver = () => {
    dispatch(changeIsHighlight(true))
  }

  const onMouseLeave = () => {
    dispatch(changeIsHighlight(false))
  }

  return (
    <div
      className={classes.highRiskCompanies}
      style={{ paddingLeft: isDynamicReport ? 50 : 0 }}
    >
      <Element className={classes.title} style={{ borderColor: '#D5D5D5' }}>
        <Translate
          value="portfolio.summary.HIGH_RISK_COMPANIES"
          className="fw600"
        />
        &nbsp; &nbsp;
        {!isDynamicReport && (
          <Icon
            className="icon-info-circle"
            style={{ color: '#9C9C9C', fontSize: 13 }}
            onMouseOver={onMouseOver}
            onMouseLeave={onMouseLeave}
          />
        )}
      </Element>

      <div className="dFlex justifyContentBetween mt1 gap3">
        <Element style={{ color: '#3A414B' }}>
          <Translate
            value="portfolio.summary.NUMBER_OF_COMPANIES"
            className="fw600"
          />
        </Element>
        <div>
          <HandleDetail
            path="PortfolioInsights/PortfolioOverviewDetails"
            otherParams={{
              timeFrequency: period,
              analyse: data?.analyseType,
              versus: data?.versusType,
              analyseId: (data?.analyseIndicators || [])
                .filter((item) => item.isHighRisk)
                .map((item) => item.id),
              versusId: (data?.versusIndicators || [])
                .filter((item) => item.isHighRisk)
                .map((item) => item.id),
            }}
          >
            {data?.highRiskCompanies?.numerOfCompanies}
          </HandleDetail>
        </div>
      </div>

      <div className="dFlex justifyContentBetween mt1 gap3">
        <Element style={{ color: '#3A414B' }}>
          <Translate
            value="portfolio.summary.PERCENT_OF_TOTAL_COMPANIES"
            className="fw600"
          />
        </Element>
        <Element style={{ color: '#3A414B' }}>
          {valToPercent(data?.highRiskCompanies?.percentage, locale, false)}
        </Element>
      </div>
    </div>
  )
}
